import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";
import type { Period } from "../../generated/core-api";

export function useMcpVelocity(
  fromDate: string,
  toDate: string,
  period: Period,
) {
  return useQuery({
    queryKey: ["platformAnalytics", "mcpVelocity", fromDate, toDate, period],
    queryFn: () =>
      api.getMcpVelocity({
        from_date: fromDate,
        to_date: toDate,
        period,
      }),
  });
}
